<template>
  <v-container
    class="pa-0"
    fluid
  >
    <v-row>
      <!-- <v-col
        cols="2"
        class="pb-0"
      >
        <v-select
          v-model="selectedLocationId"
          :items="locations"
          item-value="id"
          item-text="name"
        />
      </v-col>
      <v-spacer /> -->
      <v-col
        class="text-end mt-4"
      >
        <v-btn
          color="primary"
          outlined
          @click="open"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Panel
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="20"
            :search="search"
            :loading="loading"
            dense
          >
            <template #[`item.name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.name }}
              </text-highlight>
            </template>
            <template #[`item.description`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.description ? item.description : '' }}
              </text-highlight>
            </template>
            <template #[`item.img_w`]="{ item }">
              <a
                @click="getImage(item.id, false)"
              >
                <v-icon
                  small
                  color="primary"
                >
                  fa-image
                </v-icon>
              </a>
            </template>
            <template #[`item.img_h`]="{ item }">
              <a
                @click="getImage(item.id, true)"
              >
                <v-icon
                  small
                  color="primary"
                >
                  fa-image
                </v-icon>
              </a>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openEdit(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item.id)"
              >
                DELETE
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <panel-form
      ref="panelForm"
      @success="success"
    />
    <panel-image-form
      ref="panelImageForm"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import PanelForm from '@/components/forms/panels/PanelForm';
import PanelImageForm from '@/components/forms/panels/PanelImageForm';
import { mapState } from 'vuex';

export default {
  components: {
    PanelForm,
    PanelImageForm,
  },
  data: () => ({
    items: [],
    locations: [],
    selectedLocationId: 0,
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Description', value: 'description' },
      { text: 'Image Width', value: 'img_w' },
      { text: 'Image Height', value: 'img_h' },
      { text: 'Created At', value: 'created_at' },
      { text: 'Actions', value: 'actions', align: 'end' },
    ],
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
    }),
  },
  watch: {
    selectedLocationId() {
      this.get();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get();
    },

    async get() {
      this.loading = true;
      const submitModel = {
        filters: {
          location_id: this.selectedLocationId,
        },
      };
      this.items = await this.$api.panel.read(submitModel);
      this.loading = false;
    },

    async getImage(id, isImgH = false) {
      if (!id) return;
      const res = await this.$api.panel.get(`image/${id}`);
      if (!res) return;

      if (isImgH) {
        this.$refs.panelImageForm.openDialog(res.img_h, res.name);
      } else {
        this.$refs.panelImageForm.openDialog(res.img_w, res.name);
      }
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.panel.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.panelForm.open();
    },

    openEdit(id) {
      this.$refs.panelForm.open(id);
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },

  },
};
</script>
